import { type FC, useMemo } from 'react';

import areas from '@/components/common/select/AreaSelect/areas.json';
import { Select, type SelectProps } from '@/components/common/select/Select';
import { useLocale } from '@/hooks/use-locale';

type AreaSelectProps = Omit<SelectProps<string>, 'options'>;

export const AreaSelect: FC<AreaSelectProps> = (props) => {
  const locale = useLocale();

  const options = useMemo(
    () =>
      areas
        .map((val) => ({ value: val[locale] }))
        .sort((v1, v2) => {
          if (v1.value < v2.value) {
            return -1;
          }

          if (v1.value > v2.value) {
            return 1;
          }

          return 0;
        }),
    [locale]
  );

  return <Select options={options} {...props} />;
};
